export default "__VITE_ASSET__BYzfWszt__"